module.exports = __webpack_public_path__ + "media/Video 22.e0051c22.mp4";